import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
<div class="text-center pb-5 mb-5">
  ${until(ctx.__('<tt-zPO62F05>', 'Looks like you made some edits, do you want to save your changes before continuing?'))}
</div>

<div class="row justify-content-md-center align-items-center">
  <div class="col-lg-4 col-md-5 col-sm-7 col-xs-12 mb-2">
    <button type="button" class="btn btn-lg btn-block btn-outline-primary rounded-pill" @click="${ctx.proceed}">${until(ctx.__('<tt-J9eqFRAX>', 'Continue without Saving'))}</button>
  </div>
  <div class="col-md-4 col-sm-5 col-xs-12 mb-2">
    <button @click=${ctx.back} type="submit" class="btn btn-lg btn-block btn-primary rounded-pill">${until(ctx.__('<tt-75LI5xxr>', 'Keep Editing'))}</button>
  </div>
</div>
`;
